import type { ElementType } from 'react';
import clsx from 'clsx';
import {
  useConfirmLoginStore,
  useRecoveryConfirmationStore,
  useRecoveryStore,
  useRegisterFinalStore,
  useRegisterFirstStore,
  useRegisterVerifyStore,
  useResendCodeStore,
  useStartLoginStore,
} from '@lib/store';
import { PaletteUtils } from '@shared/utils';
import { Logo, Spinner } from '@shared/widgets';

interface NonAuthFormLayoutProps {
  className?: string;
  header?: string;
  component: ElementType;
}

export const NonAuthFormLayout = (props: NonAuthFormLayoutProps) => {
  const startLoginStore = useStartLoginStore();
  const resendCodeStore = useResendCodeStore();
  const confirmLoginStore = useConfirmLoginStore();
  const registerFirstStore = useRegisterFirstStore();
  const registerVerifyStore = useRegisterVerifyStore();
  const registerFinalStore = useRegisterFinalStore();
  const recoveryStore = useRecoveryStore();
  const recoveryConfirmationStore = useRecoveryConfirmationStore();

  const Component = props.component;
  const loading =
    startLoginStore.loading ||
    resendCodeStore.loading ||
    confirmLoginStore.loading ||
    registerFirstStore.loading ||
    registerVerifyStore.loading ||
    registerFinalStore.loading ||
    recoveryStore.loading ||
    recoveryConfirmationStore.loading;
  return (
    <>
      {loading && <Spinner position fixed />}
      <div
        className={clsx(
          'flex justify-center items-center min-h-[620px] h-full',
          PaletteUtils.isBordierPalette ? 'bg-[#f8f8f8] font-[Arial]' : 'bg-[#1e1e21] font-[Avenir,sans-serif]',
          props.className,
        )}
      >
        <div
          className={clsx(
            'border border-[#e1e1e1] w-full max-w-[440px] min-h-[500px] flex-basis-[440px] pt-[37px] px-[51px] pb-[51px]  shadow-[10px_10px_20px_0_rgba(0,0,0,0.03)] flex flex-col max-[800px]:self-stretch max-[800px]:pt-[20px] max-[800px]:px-[40px] max-[800px]:pb-[40px]',
            PaletteUtils.isBordierPalette ? 'bg-[#ffffff]' : 'bg-[#27272b] border-none',
          )}
        >
          <Logo className={clsx('mb-[14px] text-[37px] mx-auto', PaletteUtils.isBordierPalette ? '' : '!h-[42px]')} />
          <h1
            className={clsx(
              'mt-0 mb-[23px] text-[14px] font-[500] uppercase text-center tracking-[1.7px]',
              PaletteUtils.isBordierPalette ? 'text-[#dc291c]' : 'text-[#e5c496]',
            )}
          >
            {props.header}
          </h1>
          <Component />
        </div>
      </div>
    </>
  );
};
